import Mutations from '../../odata/mutations';

export default { ...new Mutations('farm'), ...new Mutations('farms') };
